import urls from "../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../utils/service";

export interface BannerItem {
  index: number;
  link: string;
  image: string;
}

export const getBanners = async (): Promise<BannerItem[]> => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.bannersApi, callParams);
    const items = response?.items ?? (Array.isArray(response) ? response : []);
    return (items as BannerItem[]).filter(
      (item) => item?.image && item?.link?.trim()
    );
  } catch {
    return [];
  }
};
